import '../../styles/blocks/_messages-screen.scss';

import React, { useEffect } from 'react';
import { formatText, FormattedText } from 'core/i18n';
import { deleteCookie, logoutUser } from 'utilities/logoutHelper';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import logActions from 'actions/logActions';
import MessagesScreen from 'components/messagesScreen/messagesScreen';
import { PUBLICA_URL, ALLOW_COOKIE } from 'constants/index';

const LogoutComponent = ({ dispatch, userProfile }) => {
    const iconClass = 'icons icons--icon-success-green-old';
    const title = formatText('logout-successfullySaved');
    const buttonText = formatText('button-understood');
    const buttonClass = 'form__button form__button-secondary';
    const buttonAction = () => {
        window.location.href = PUBLICA_URL;
    };

    useEffect(() => {
        logoutUser(dispatch, userProfile);
        ALLOW_COOKIE && deleteCookie();
    }, []);

    return (
        <div>
            <MessagesScreen
                iconClass={iconClass}
                title={title}
                buttonText={buttonText}
                buttonClass={buttonClass}
                action={buttonAction}
            >
                <FormattedText value="logout-logoutInfo" />
            </MessagesScreen>
        </div>
    );
};

const mapStateToProps = state => ({
    userProfile: state.userProfile,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    logActions: bindActionCreators(logActions, dispatch),
});

export const Logout = connect(mapStateToProps, mapDispatchToProps)(LogoutComponent);
